import { render } from "./SimulationPage.vue?vue&type=template&id=5c3590a9"
const script = {}

import exportComponent from "/home/n3rdy/dev/virtuallab-networksecurity/exp-6/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__